import CheckoutManualPage, { CheckoutManualPageProps } from './CheckoutManualPage';
import withInteractor from './CheckoutManualPage.interactor';
import withPresenter from './CheckoutManualPage.presenter';

export type { CheckoutManualPageProps };
export default withInteractor(withPresenter(CheckoutManualPage));
